const link = window.location.origin;
const storeLink =
    'https://play.google.com/store/apps/details?id=com.morfie.kanisa';

const sharePost = (url, text, title) => {
    if (navigator.share) {
        navigator
            .share({ title: title || 'Kanisa App | Guest Feed', text, url })
            .then(() => {})
            // eslint-disable-next-line no-console
            .catch((error) => console.log('Error sharing', error));
    }
};

export const handleGuestFeedShare = (feed, type) => {
    const { id, stream, audio, media, title, name, church, member } = feed;
    const postTitle = title || name;

    stream &&
        sharePost(
            storeLink,
            `Watch "${church?.name}" video on "${postTitle}" in myKanisa App.
            
            👉 ${link}/guest-feed/${id}?type=${type}
            
            ⬇️ Download myKanisa on PlayStore.`
        );

    audio &&
        sharePost(
            storeLink,
            `Listen to  "${church?.name}" devotion on "${postTitle}" in myKanisa App.
            
            👉 ${link}/guest-feed/${id}?type=${type}
            
            ⬇️ Download myKanisa on PlayStore.`
        );

    media &&
        sharePost(
            storeLink,
            `View ${member?.name}'s post from "${church?.name}" in myKanisa App.
            
            👉 ${link}/guest-feed/${id}?type=${type}
            
            ⬇️ Download myKanisa on PlayStore.`
        );
};

export const shareCrusade = (crusade) => {
    const owner = crusade?.church?.name || crusade?.pastor?.name;
    const crusadeTitle = crusade?.title || crusade?.name;
    sharePost(
        storeLink,
        `Join ${owner}'s crusade on "${crusadeTitle}" in myKanisa App.
        
        👉 ${link}/crusade/${crusade.id}
        
        ⬇️ Download myKanisa on PlayStore.`
    );
};

export const shareChurch = (churchId, churchName) => {
    sharePost(
        storeLink,
        `Check out "${churchName}" profile on myKanisa App.
            
        👉 ${link}/church/${churchId}
            
        ⬇️ Download myKanisa on PlayStore.`
    );
};

export const shareMinister = (username, fullName) => {
    sharePost(
        storeLink,
        `Check out minister "${fullName}" profile on myKanisa App.
            
        👉 ${link}/minister/${username}
            
        ⬇️ Download myKanisa on PlayStore.`
    );
};

export default sharePost;
